<section>
  <div class="flex header">
    @if (props.label) {
      <legend>{{ props.label }}</legend>
    }
  </div>
  @if (props.description) {
    <p>{{ props.description }}</p>
  }
  @for (field of field.fieldGroup; track field) {
    <formly-field [field]="field"></formly-field>
  }
</section>
